/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Refresh_AriaInputs */



/**
* | output |
* | --- |
* | "Refresh folders" |
*
* @param {Explorer_Nav_Refresh_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_refresh_aria = /** @type {((inputs?: Explorer_Nav_Refresh_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Refresh_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actualiser les dossiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna cartelle")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить папки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar carpetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("刷新文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダを更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर रीफ़्रेश करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar pastas")
	return /** @type {LocalizedString} */ ("Refresh folders")
});